export class BoundedInt {
  static capInput(raw: string, min: number, max: number): string {
    const trimmed = raw.trim();
    if (!trimmed) return "";
    const n = Number.parseInt(trimmed, 10);
    if (!Number.isFinite(n)) return "";
    return String(Math.min(max, Math.max(min, n)));
  }
}
